import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';

// const styles = StyleSheet.create({
//   page: {
//     padding: 30,
//     fontSize: 10,
//     fontFamily: 'Helvetica',
//     borderWidth: 3,
//     borderColor: '#000',
//     borderStyle: 'solid',
//   },
//   header: {
//     textAlign: 'center',
//     marginBottom: 10,
//   },
//   bold: {
//     fontWeight: 'bold',
//   },
//   row: {
//     flexDirection: 'row',
//     borderBottom: '1 solid #ccc',
//     borderLeft: '1 solid #ccc',
//     borderRight: '1 solid #ccc',
//     paddingVertical: 4,
//   },
//   cell: {
//     flex: 1,
//     paddingHorizontal: 2,
//   },
//   tableHeader: {
//     flexDirection: 'row',
//     borderTop: '1 solid #ccc',
//     borderBottom: '1 solid #ccc',
//     borderLeft: '1 solid #ccc',
//     borderRight: '1 solid #ccc',
//     paddingVertical: 4,
//     marginTop: 5,
//   },
//   footer: {
//     marginTop: 30,
//     fontSize: 10,
//   },

//   rowTotal: {
//     flexDirection: 'row',
//     paddingVertical: 4,
//   },
// });

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
    borderWidth: 2,
    borderColor: '#000',
    borderStyle: 'solid',
  },
  header: {
    textAlign: 'center',
    marginBottom: 10,
  },
  bold: {
    fontWeight: 'normal',
  },

  // Table header row style
  tableHeader: {
    flexDirection: 'row',
    marginTop: 5,
  },

  // Header cell style
  headerCell: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderColor: '#ccc',
    fontWeight: 'bold',
  },

  headerCell1: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderColor: '#ccc',
    fontWeight: 'bold',
  },

  // Data row container
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#ccc',
  },

  // Data cell style

  // Add bottom border to last row
  lastRowCell: {
    // borderBottomWidth: 1,
    // borderColor: '#ccc',
  },

  footer: {
    marginTop: 30,
    fontSize: 10,
  },

  rowTotal: {
    flexDirection: 'row',
    paddingVertical: 2,
    paddingHorizontal: 4,
  },

  cellTotal: {
    flex: 1,
    paddingVertical: 2,
    paddingHorizontal: 4,
    marginLeft: 4,
  },

  cell: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: '#ccc',
  },

  cell1: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderRightWidth: 1,
    borderColor: '#ccc',
  },

  detailsRow: {
    marginBottom: 3,
  },
});

const InvoicePDF = ({ customerDetails, products, totalPrice }) => {
  const vat = (Number(totalPrice) * 18) / 100;
  const totalWithVAT = Number(totalPrice) + vat;
  const formattedDate = new Date().toLocaleString();

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <View style={styles.header}>
          <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 2 }}>SRI KANTH PROFESSIONAL KITCHEN (PVT) LTD</Text>
          <Text>No 06, Kotugodalla Veediya, Kandy</Text>
          <Text>T. 081 2237855 | F. 081 2237620 | E. info@srikanthprofessional.com</Text>
          <Text>W. www.srikanthprofessional.com</Text>
          <Text style={{ marginTop: 4, fontSize: 10, fontWeight: 600 }}>Tax Invoice | VAT Reg. Number: 409009107700</Text>
        </View>

        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 }}>
          {/* Left Column */}
          <View style={{ flex: 1 }}>
            <Text style={{ fontWeight: 'bold', marginBottom: 5 }}>Invoice Details</Text>

            <Text style={styles.detailsRow}>Customer Name: {customerDetails.customerName}</Text>
            <Text style={styles.detailsRow}>Address: {customerDetails.customerAddress}</Text>
            <Text style={styles.detailsRow}>Customer REF No: {customerDetails.customerREFNo}</Text>
            {customerDetails.customerVatNo && <Text style={styles.detailsRow}>Customer VAT No: {customerDetails.customerVatNo}</Text>}
          </View>

          {/* Right Column */}
          <View style={{ flex: 1, alignItems: 'flex-end' }}>
            <Text style={{ fontWeight: 'bold', marginBottom: 5 }}>Reference Info</Text>
            <Text style={styles.detailsRow}>Invoice No: {customerDetails.invoiceNo}</Text>
            <Text style={styles.detailsRow}>Date: {formattedDate}</Text>
            <Text style={styles.detailsRow}>SK REF No: {customerDetails.SKREFNo}</Text>
          </View>
        </View>
        {/* <Text>VAT Reg. Number: 409009107700</Text> */}

        {/* Table */}
        <View style={styles.tableHeader}>
          <Text style={styles.headerCell}>Product</Text>
          <Text style={styles.headerCell1}>Quantity</Text>
          <Text style={styles.headerCell1}>Unit Price</Text>
          <Text style={{ ...styles.headerCell1, borderRightWidth: 1 }}>Total</Text>
        </View>
        {products
          .filter((item) => item.enteredQuantity > 0)
          .map((item, i, filteredProducts) => {
            const name = item.productName || item.product.productName;
            const qty = item.enteredQuantity;
            const price = Number(item.sellingPrice || item.product.sellingPrice);
            const total = price * qty;

            const isLastRow = i === filteredProducts.length - 1;

            return (
              <View style={styles.row} key={i} wrap={false}>
                <Text style={[styles.cell, isLastRow && styles.lastRowCell]}>{name}</Text>
                <Text style={[styles.cell1, isLastRow && styles.lastRowCell]}>{qty}</Text>
                <Text style={[styles.cell1, isLastRow && styles.lastRowCell]}>Rs.{price.toFixed(2)}</Text>
                <Text style={[styles.cell1, isLastRow && styles.lastRowCell]}>Rs.{total.toFixed(2)}</Text>
              </View>
            );
          })}

        {/* Totals */}
        <View style={{ marginTop: 10 }} wrap={false}>
          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.bold]}>Discount</Text>
            <Text style={[styles.cellTotal, styles.bold]}>Rs.{Number(customerDetails.discount).toFixed(2)}</Text>
          </View>
          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.bold]}>Total Price</Text>
            <Text style={[styles.cellTotal, styles.bold]}>Rs.{(Number(totalPrice) + Number(customerDetails.discount)).toFixed(2)}</Text>
          </View>
          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.bold]}>18% VAT</Text>
            <Text style={[styles.cellTotal, styles.bold]}>Rs.{vat.toFixed(2)}</Text>
          </View>
          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.bold]}>Total Bill with VAT</Text>
            <Text style={[styles.cellTotal, styles.bold]}>Rs.{totalWithVAT.toFixed(2)}</Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>* Credit period 14 days.</Text>
          <Text>* Please acknowledge receipt by scanned mail to info@srikanthprofessional.com.</Text>
          <Text>* This is a computer generated invoice that does not require a signature.</Text>
          <Text>* Cheques to be drawn in favor of "Sri Kanth Professional Kitchen (Pvt) Ltd" and crossed "Account Payee".</Text>
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePDF;
